import { render, staticRenderFns } from "./BaseInfoCardSmall.vue?vue&type=template&id=eaedf43c&scoped=true"
import script from "./BaseInfoCardSmall.vue?vue&type=script&lang=js"
export * from "./BaseInfoCardSmall.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoCardSmall.vue?vue&type=style&index=0&id=eaedf43c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaedf43c",
  null
  
)

export default component.exports